import { render, staticRenderFns } from "./ThankLogin.vue?vue&type=template&id=4c7e1f6e&scoped=true&"
import script from "./ThankLogin.vue?vue&type=script&lang=js&"
export * from "./ThankLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e1f6e",
  null
  
)

export default component.exports